<template>
  <div class="timeline">
    <div v-if="loading" class="timeline-item is-secondary">
      <div class="timeline-item-main">
        <div class="timeline-item-date">Pågår</div>
        <div class="timeline-item-content">
          <strong>Hämtar aktivitet...</strong>
        </div>
      </div>
    </div>

    <div
      v-for="comment in comments"
      :key="comment.id"
      class="timeline-item"
      :class="[getColor(comment),isComment(comment)]"
    >
      <div class="timeline-item-main" :title="comment.created_at">
        <div class="timeline-item-date">{{ moment(comment.created_at).format('YYYY-MM-DD HH:mm') }}</div>
        <div class="timeline-item-content">
          <strong>{{ $t(getText(comment)) }}</strong>

          <template v-if="comment.properties.applies_to">(avser sida {{ comment.properties.applies_to }})</template>
          <template v-if="getText(comment) == 'status_done'">
            <strong v-if="printable.exported_at">{{ printable.delivered_at.split(' ')[0] }}</strong>
          </template>
          <template v-if="getText(comment) == 'status_delivered'">
            <strong v-if="printable.exported_at">{{ printable.exported_at.split(' ')[0] }}</strong>
          </template>
          -
          <span v-if="comment.causer">{{ comment.causer.name }}</span>
          <span v-else>Användare borttagen</span>
          <br />
          <p class="mb-0" v-if="comment.properties.comment">{{ comment.properties.comment }}</p>
          <div class="mt-1" v-if="comment.properties.attachment">
            <span v-if="!Array.isArray(comment.properties.attachment)">
              <fa :icon="['fal','paperclip']" />
              <a
                :href="'/api/' + comment.properties.attachment.path"
                target="_blank"
              >{{ comment.properties.attachment.filename }}</a>
            </span>
            <span
              v-else
              v-for="attachment in comment.properties.attachment"
              :key="attachment.id"
              class="mr-3"
            >
              <fa :icon="['fal','paperclip']" />
              <a
                :href="attachment.prefix + attachment.path"
                target="_blank"
              >{{ attachment.filename }}</a>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!loading && comments.length == 0" class="timeline-item is-secondary">
      <div class="timeline-item-main">
        <div class="timeline-item-date"></div>
        <div class="timeline-item-content">
          <strong>Aktiviteter saknas</strong>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "Timeline",
  data() {
    return {
      loading: true,
      comments: []
    };
  },
  created() {
    this.fetchComments();
  },
  watch: {
    newComment(newC, oldC) {
      this.fetchComments();
    }
  },
  methods: {
    isComment(comment) {
      if (comment.description == "comment") {
        return "user-comment";
      } else {
        return "";
      }
    },
    getColor(comment) {
      let color, key;

      if (comment.description == "status") {
        key = comment.properties.now;
      } else {
        key = comment.description;
      }

      return "is-" + this.status.color(key);
    },
    getText(comment) {
      if (comment.description == "status") {
        return "status_" + comment.properties.now;
      } else {
        return comment.description;
      }
    },
    async fetchComments() {
      this.loading = true;
      const { data } = await axios.get(
        "/api/comment-printable/" + this.printableId
      );
      this.comments = data;

      this.loading = false;
      //this.$emit('loaded');
    }
  },
  props: ["printable","printableId", "newComment"]
};
</script>

<style lang="scss" scoped>
$gray: #f0f0f0;

.user-comment .timeline-item-main {
  position: relative;
  background: $gray;
  border-radius: 0.4em;
  padding: 1rem;
  max-width: 50%;
  margin-bottom: 1rem;
}

.user-comment .timeline-item-main:after {
  content: "";
  position: absolute;
  left: 0;
  top: 10%;
  width: 0;
  height: 0;
  border: 22px solid transparent;
  border-right-color: $gray;
  border-left: 0;
  border-top: 0;
  margin-left: -15px;
  z-index: -1;
}
</style>




// WEBPACK FOOTER //
// resources/assets/js/components/Timeline.vue